<template>
    <div class="heatmap-sorter-level">
        <div v-if="!editing">{{ updatedTrack }}</div>
        <div v-else>
            <v-autocomplete
                dense
                v-model="updatedTrack"
                :items="allTracks"
            >
            </v-autocomplete>
        </div>

        <div v-if="!editing">
            <v-btn
                icon
                color="grey"
                x-small
                @click="editing = true"
                style="margin-left: 10px;"
                hint="test"
            >
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
        </div>
        <div v-else>
            <v-btn
                icon
                color="green"
                small
                @click="updateLockTrack"
                style="margin-left: 10px;"
            >
                <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
                v-if="lockTracksLength > 1"
                icon
                color="red"
                small
                @click="removeLockTrack"
                style="margin-left: 10px;"
            >
                <v-icon>mdi-delete</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    name: "heatmap-sorter-level",
    
    props: ['track', 'i', 'lockTracksLength'],

    computed: {
        allTracks() {
            // POSSIBLE PROBLEM
            console.log("looking at allTracks in HeatmapSorterLevel.vue");
            // console.log(Object.keys(this.$store.state.Heatmap_data));

            // // I want to go through all of the object keys
            // // the set should have no duplicates and it should be returned as an array
            // // I want to return the array

            let allTracks = new Set()
            for (const key in this.$store.state.Heatmap_data) {

                // split the word and check if it ends with Male or Female as its last word
                console.log("checking key");
                console.log(key.split(" ").at(-1));
                if( (key.split(" ").at(-1) === "Male") || (key.split(" ").at(-1) === "Female") ){
                    // if it does, add the key to the set
                    let newKey = key.split(" ").slice(0, -1).join(" ")
                    console.log("checking newKey");

                    console.log(newKey);
                    allTracks.add(newKey)
                }
                else {
                    allTracks.add(key)
                }
            }

            console.log("allTracks in HeatmapSorterLevel.vue");
            console.log(allTracks);
            // convert the set to an array
            allTracks = Array.from(allTracks)

            return allTracks;
        },
    },

    data: () => ({
        editing: false,
        updatedTrack: '',
    }),

    watch: {
    },

    methods: {
        removeLockTrack() {
            this.editing = false
            this.$emit(
                'removeLockTrack', 
                { 
                    i: this.i,
                }
            )
        },
        updateLockTrack() {
            this.editing = false
            if (this.updatedTrack === 'Search tracks') {
                this.$emit(
                    'removeLockTrack', 
                    { 
                        i: this.i,
                    }
                )
            } else {
                this.$emit(
                    'updateLockTrack', 
                    { 
                        updatedTrack: this.updatedTrack,
                        i: this.i,
                    }
                )

            }
        },
    },

    mounted() { 
        this.updatedTrack = this.track
        if (this.track === 'Search tracks') {
            this.editing = true
        }
    },
}
</script>

<style>
.heatmap-sorter-level {
    width: 100%;
    display: flex;
    flex-direction: row;
    border: solid 1px #ebebeb;
    padding: 2px 10px;
    justify-content: space-between;
}

.heatmap-sorter-level span {
    margin-left: 5px;
}

</style>